import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, titles, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 10001,
	},
	modal: {
		backgroundColor: white,
		borderRadius: 12,
		boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
		width: 480,
		maxWidth: '90vw',
		maxHeight: '80vh',
		display: 'flex',
		flexDirection: 'column',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '20px 24px 0',
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		color: titles,
		margin: 0,
	},
	closeButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 32,
		height: 32,
		padding: 0,
		border: 'none',
		borderRadius: 6,
		backgroundColor: 'transparent',
		color: '#6b7280',
		cursor: 'pointer',
		transition: 'all 0.15s ease',
		':hover': {
			backgroundColor: '#f3f4f6',
			color: titles,
		},
	},
	description: {
		fontSize: 14,
		color: '#6b7280',
		margin: '8px 24px 0',
		lineHeight: 1.5,
	},
	body: {
		flex: 1,
		overflow: 'auto',
		padding: '16px 24px',
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	defaultSegmentContainer: {
		marginTop: 16,
	},
	defaultSegmentDivider: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 8,
	},
	defaultSegmentLabel: {
		fontSize: 11,
		fontWeight: 500,
		color: '#9ca3af',
		textTransform: 'uppercase' as const,
		letterSpacing: '0.5px',
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 12,
		padding: '16px 24px 20px',
		borderTop: '1px solid #e5e7eb',
	},
	button: {
		padding: '10px 20px',
		fontSize: 14,
		fontWeight: 500,
		borderRadius: 6,
		cursor: 'pointer',
		transition: 'all 0.15s ease',
	},
	buttonSecondary: {
		backgroundColor: white,
		border: '1px solid #d1d5db',
		color: titles,
		':hover': {
			backgroundColor: '#f9fafb',
			borderColor: '#9ca3af',
		},
	},
	buttonPrimary: {
		backgroundColor: brandPrimaryText,
		border: `1px solid ${brandPrimaryText}`,
		color: white,
		':hover': {
			opacity: 0.9,
		},
	},
});
